import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'twilio-video';
import './VideoCall.css';

const VideoCall = ({ token, roomName }) => {
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const roomRef = useRef(null);

  useEffect(() => {
    if (token) {
      const connectToRoom = async () => {
        try {
          const room = await connect(token, { name: roomName });
          roomRef.current = room;

          // Exibir o vídeo local
          room.localParticipant.videoTracks.forEach((publication) => {
            const track = publication.track;
            localVideoRef.current.appendChild(track.attach());
            localVideoRef.current.style.backgroundColor = 'transparent'; // Remover o fundo preto quando o vídeo carregar
          });

          // Exibir o vídeo remoto
          room.on('participantConnected', (participant) => {
            participant.videoTracks.forEach((publication) => {
              const track = publication.track;
              remoteVideoRef.current.appendChild(track.attach());
              remoteVideoRef.current.style.backgroundColor = 'transparent'; // Remover o fundo preto quando o vídeo carregar
            });

            participant.on('trackSubscribed', (track) => {
              remoteVideoRef.current.appendChild(track.attach());
              remoteVideoRef.current.style.backgroundColor = 'transparent'; // Remover o fundo preto quando o vídeo carregar
            });
          });

          room.on('participantDisconnected', (participant) => {
            participant.videoTracks.forEach((publication) => {
              const track = publication.track;
              track.detach().forEach((element) => element.remove());
            });
          });
        } catch (error) {
          console.error('Erro ao conectar à sala do Twilio:', error);
        }
      };

      connectToRoom();
    }

    return () => {
      if (roomRef.current) {
        roomRef.current.disconnect();
        roomRef.current = null;
      }
    };
  }, [token, roomName]);

  return (
    <div className="video-call-container">
      <div className="local-video" ref={localVideoRef}></div>
      <div className="remote-video" ref={remoteVideoRef}></div>
    </div>
  );
};

VideoCall.propTypes = {
  token: PropTypes.string.isRequired,
  roomName: PropTypes.string.isRequired,
};

export default VideoCall;
